var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"fixed h-screen flex items-center justify-center z-50 inset-0"},[_c('CircleLoading',{attrs:{"width":90,"theme":"gray"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }